"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenObject = void 0;
function flattenObject(object, separator = '-') {
    let flatObject = {};
    for (let prop in object) {
        if (!Object.prototype.hasOwnProperty.call(object, prop))
            continue;
        if (typeof object[prop] === 'object' && object[prop] !== null) {
            const nestedFlatObject = flattenObject(object[prop], separator);
            for (let nestedProp in nestedFlatObject) {
                if (!Object.prototype.hasOwnProperty.call(nestedFlatObject, nestedProp))
                    continue;
                flatObject[prop + separator + nestedProp] =
                    nestedFlatObject[nestedProp];
            }
        }
        else {
            flatObject[prop] = object[prop];
        }
    }
    return flatObject;
}
exports.flattenObject = flattenObject;
